import { MapContentLayer } from '../MapContentLayer';
import { CircleLayerSpecification, LayerSpecification } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { TrackStyles } from '../../../../../configuration/model/TrackStyles';

export class ImageCircleLayer extends MapContentLayer {

  constructor(
    source: MapContentSource,
    private trackStyles: TrackStyles,
  ) {
    super('image-circle-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'circle',
      source: this.sourceRef.sourceId,
      paint: {
        'circle-color': [
          'case',
          ['boolean', ['get', 'highlighted']],
          'darkblue',
          this.trackStyles.shiftPlowNormal.color,
        ],
        'circle-radius': this.trackStyles.shiftPlowNormal.width + 1,
        'circle-stroke-width': 10,
        'circle-opacity': [
          'step',
          ['zoom'],
          ['case',
            ['boolean', ['get', 'highlighted']],
            1.0,
            0.0,
          ],
          16,
          1.0,
        ],
        'circle-stroke-opacity': 0,
      },
    } as CircleLayerSpecification;
  }

}
